import { jsx as l } from "react/jsx-runtime";
import "react";
var a = (o) => /* @__PURE__ */ l("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 36 36",
  ...o,
  children: /* @__PURE__ */ l("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m17.283 31.754-.003-.002-.007-.006-.026-.02-.094-.075c-.08-.065-.198-.16-.347-.283a47.564 47.564 0 0 1-4.923-4.713c-1.346-1.495-2.718-3.243-3.76-5.093-1.034-1.84-1.79-3.866-1.79-5.895a11.667 11.667 0 0 1 23.334 0c0 2.029-.756 4.055-1.79 5.895-1.042 1.85-2.414 3.598-3.76 5.093a47.58 47.58 0 0 1-5.364 5.07l-.026.02-.007.007-.002.001s-.002.001-.718-.92l.716.921a1.167 1.167 0 0 1-1.433 0Zm.717-.92-.717.92.717-.92Zm3.5-15.167a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z",
    clipRule: "evenodd"
  })
});
export {
  a as default
};
